// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BroadcastRoomSubject{box-sizing:border-box;padding:4px 8px;border-radius:8px;background:rgba(74,74,74,.5);width:fit-content;max-width:100%;min-height:0}.BroadcastRoomSubject div{height:100%}.BroadcastRoomSubject__text{overflow-wrap:break-word;overflow-y:scroll}.EmptySubjectSpacer{height:30px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
